import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from, BehaviorSubject} from 'rxjs';
import { BlobServiceClient, ContainerClient, BlockBlobUploadOptions } from '@azure/storage-blob';
import { CookieService } from 'ngx-cookie-service';
import { defaultRecordData, recordsDataInterface } from '../../../../model/unsubscribe.interface';

@Injectable({
  providedIn: 'root'
})
export class ImportOptoutsModalService {

  fileId = new BehaviorSubject<number | null>(null);
  fileId$ = this.fileId.asObservable();

  isEmailOrPrimaryPhoneNumberColumnPresent = new BehaviorSubject<boolean>(false);
  isEmailOrPrimaryPhoneNumberColumnPresent$ = this.isEmailOrPrimaryPhoneNumberColumnPresent.asObservable();

  isFileValidating = new BehaviorSubject<boolean>(false);
  isFileValidating$ = this.isFileValidating.asObservable();

  isDataMappingGridPopulated = new BehaviorSubject<boolean>(false);
  isDataMappingGridPopulated$ = this.isDataMappingGridPopulated.asObservable();

  recordsData = new BehaviorSubject<recordsDataInterface>(defaultRecordData);
  recordsData$ = this.recordsData.asObservable();


  headers;
  private blobServiceClient: BlobServiceClient;
  private containerClient: ContainerClient;
  private heartbeatInterval: any = null;
  private currentFileName: string | null = null;

  private selectedDomain: string = '';
  setSelectedDomain(selectedDomain: string) {
      //create a variable to hold selected domain
      this.selectedDomain = selectedDomain;
  }
  // reset selected domain
  resetSelectedDomain() {
      this.selectedDomain = '';
  }

  private initClients(sasUrl: string, containerName: string, sasToken: string): void {
    const sasUrlAuth = sasUrl +`?${sasToken}`;
    this.blobServiceClient = new BlobServiceClient(sasUrlAuth);
    this.containerClient = this.blobServiceClient.getContainerClient(containerName);
  }

  constructor(private http: HttpClient,private cookieService: CookieService, private zone: NgZone) {
    this.headers = new HttpHeaders()
    .set('Content-Type', 'application/json;charset=utf-8')
   }

  patientFileUploadApi: string = "/api/v1/platform/patient-file-upload";
  sasUrl: string = `/api/v1/platform/patient-file-upload/opt-out/getSas`;
  uploadFileApi: string = '/api/v1/platform/marketing-automation-campaign/upload-file';
  validatePatientListAPI: string = '/api/v1/platform/validate-patient-list/opt-out-validate';
  validatePatientListDetailAPI: string = '/api/v1/platform/validate-patient-list';
  sseValidationURL: string = 'api/v1/platform/validate-patient-list/opt-out-file-validation-events/';
  sseFileDownloadValidationURl: string = 'api/v1/platform/validate-patient-list/opt-out-error-file-download-events';
  fileUploadConfimation : string = '/api/v1/platform/validate-patient-list/create-upload-opt-out-patients'
  sseUploadConfirmation : string = '/api/v1/platform/validate-patient-list/upload-file-events/'
  unlayerTokenApi:string = "api/v1/platform/unlayer-editor-token";
  heartbeatApi: string = '/api/v1/platform/patient-file-upload/opt-out-heartbeat';


  validateFile(incomingObject:any){
    let obj = {
      fileName:incomingObject.fileName,
      mappings:incomingObject.mappings,
      contentType: incomingObject.contentType,
      originalFileSize: incomingObject.originalFileSize,
      commType: incomingObject.commType
    }
    return this.http.post<any>(this.validatePatientListAPI , obj)
  }

  saveFileStatus(object: any): Observable<any> {
    const auditObj = {
      contentType: object.contentType,
      originalFileSize: object.originalFileSize,
      fileName: object.fileName,
      isComplete: object.isComplete,
      isProcessing: object.isProcessing,
      isValidated: object.isValidated
    }
    return this.http.post<any>(this.patientFileUploadApi + `/createPatientFileUploadAudit`, auditObj)
  }

  getSasUrl() {
    return this.http.get(this.sasUrl, { headers: this.headers });
  }

  recordsDataReset() : void{
    this.recordsData.next(defaultRecordData);
  }

  sendFileToAzureBlob(sasUrl:string, containerName:string, sasToken:string, file:any): Observable<any>{
    const options: BlockBlobUploadOptions = {
      blobHTTPHeaders: {
        blobContentType: file.type,
      },
      onProgress: (ev) => {
        const progress = (ev.loadedBytes / file.size) * 100;
      }
    };
    this.initClients(sasUrl, containerName, sasToken);

    const blobClient = this.containerClient.getBlockBlobClient(file.name);
    return from(blobClient.uploadData(file, options));
  }

  getFileFromAzureBlob(sasUrl:string, containerName:string, sasToken:string, file:any): Observable<any>{
    this.initClients(sasUrl, containerName.toLowerCase(), sasToken);
    const blobClient = this.containerClient.getBlockBlobClient(file);
    return from(
      blobClient.download().then((response) => {
        return response.blobBody;
      })
    );
  }

  saveFile(fileBlob: Blob, fileName: string) {
    const fileNameWithoutId = fileName.replace(/^(.+?)_\d+(_Error)?(\.\w+)$/, '$1$2$3');
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(fileBlob);
    link.download = fileNameWithoutId;
    link.click();
  }

  getValidationSSE(fileName: string,type : 'validation' | 'upload'): Observable<any>{
    return new Observable((observer) => {
      let customerUrlPrefix = window.location.hostname.split("-")[0];
      customerUrlPrefix = customerUrlPrefix + "-admin"
      let cookie = this.cookieService.get(customerUrlPrefix);
      let tokenCookie;
      let authToken;
      if (cookie) {
        tokenCookie = JSON.parse(cookie);
        authToken = tokenCookie.access_token
      }

      const eventSource = new EventSource(`${this.sseValidationURL}${fileName}`, {withCredentials: true});

      eventSource.onmessage = (event) => {
        this.zone.run(() => {
          const data = JSON.parse(event.data);
          observer.next(data);

          // Close the connection when "COMPLETED" status is received
          if (type === 'validation' && data.status && data.status.toUpperCase() === 'COMPLETED' || type === 'upload' && data.status && data.status.toUpperCase() === 'UPLOADED') {
            eventSource.close();
            observer.complete();
          } else if (data.status && data.status.toUpperCase() === 'ERROR') {
            eventSource.close();
            observer.error(data);
          }
        });
      };

      eventSource.onerror = (error) => {
        this.zone.run(() => {
          observer.error(error);
          eventSource.close();
        });
      };

      return () => {
        eventSource.close();
      };
    });
  }

  getFileUploadEventsPool(fileName: string): Observable<any>{
    const obj = {"fileName": fileName };

    return this.http.get<any>(this.validatePatientListAPI + `upload-file-events-pooling/${fileName}`)
  }

  getDownloadEventsPool(fileName: string): Observable<any>{
    const obj = {"fileName": fileName };

    return this.http.get<any>(this.validatePatientListAPI + `error-file-download-events-pooling/${fileName}`)
  }

  getDownloadServerSentEvent(fileName: string): Observable<any> {
    return new Observable((observer) => {
      var customerUrlPrefix = window.location.hostname.split("-")[0];
      customerUrlPrefix = customerUrlPrefix + "-admin"
      var cookie = this.cookieService.get(customerUrlPrefix);
      var tokenCookie;
      var authToken;
      if (cookie) {
        tokenCookie = JSON.parse(cookie);
        authToken = tokenCookie.access_token
      }

      const eventSource = new EventSource(`${this.sseFileDownloadValidationURl}/${fileName}`,{withCredentials:true});

      eventSource.onmessage = (event) => {
        this.zone.run(() => {
          const data = JSON.parse(event.data);
          observer.next(data);

          // Close the connection when "validated" message is received
          if (data.status && data.status.toUpperCase() === 'COMPLETED') {
            eventSource.close();
            observer.complete();
          } else if(data.status && data.status.toUpperCase()==='ERROR'){
            eventSource.close();
          }
        });
      };

      eventSource.onerror = (error) => {
        this.zone.run(() => {
          observer.error(error);
        });
      };

      return () => {
        eventSource.close();
      };
    });
  }

  getSummarizedReport(fileId: number): Observable<any> {
    return this.http.get<any>(`${this.patientFileUploadApi}/getOptoutFileUploadAudit/${fileId}`)
  }

  getDetailedReport(page: number,limit: number,fileName: string,): Observable<any> {
    const obj = { "limit": limit, "pageNumber": page, "fileName": fileName };

    return this.http.get<any>(this.validatePatientListDetailAPI + `/opt-out-file-details/`, { params: obj })
  }

  onFileUploadConfirmation(fileName:string){
    let obj = {
      fileName:fileName,
      domain:this.selectedDomain
    }
    return this.http.post<any>(this.fileUploadConfimation , obj)
  }

  refreshToken(){
    return this.http.get<any>(this.unlayerTokenApi + '/')  // for polling purpose
  }

  /**
   * Start sending heartbeat signals to the server
   * @param fileName The name of the file being processed
   * @param intervalMs Heartbeat interval in milliseconds (default: 30 seconds)
   */
  startHeartbeat(fileName: string, intervalMs: number = 30000): void {
    // Stop any existing heartbeat
    this.stopHeartbeat();

    // Store current filename with fileId
    this.currentFileName = fileName;

    // Send initial heartbeat
    this.sendHeartbeat();

    // Setup interval for periodic heartbeats
    this.heartbeatInterval = setInterval(() => {
      this.sendHeartbeat();
    }, intervalMs);

    // Listen for page visibility changes
    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));

    // Listen for beforeunload event to cleanup on page close
    window.addEventListener('beforeunload', this.handleBeforeUnload.bind(this));
  }

  /**
   * Stop sending heartbeat signals
   */
  stopHeartbeat(): void {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
      this.heartbeatInterval = null;
    }

    // Remove event listeners
    document.removeEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
    window.removeEventListener('beforeunload', this.handleBeforeUnload.bind(this));

    this.currentFileName = null;
  }

  /**
   * Send a single heartbeat signal to the server
   */
  private sendHeartbeat(): void {
    if (!this.currentFileName) return;

    this.http.post(this.heartbeatApi, { fileName: this.currentFileName })
      .subscribe({
        error: (err) => {
          console.error('Heartbeat failed:', err);
        }
      });
  }

  /**
   * Handle visibility change (tab switch, minimize, etc.)
   */
  private handleVisibilityChange(): void {
    if (document.hidden && this.currentFileName) {
      // Send heartbeat before tab becomes hidden
      this.sendHeartbeat();
    }
  }

  /**
   * Handle beforeunload event (page close/refresh)
   */
  private handleBeforeUnload(): void {
    if (this.currentFileName) {
      // Try to send final heartbeat using sendBeacon (more reliable on unload)
      const blob = new Blob([JSON.stringify({ fileName: this.currentFileName })], { type: 'application/json' });
      navigator.sendBeacon(this.heartbeatApi, blob);
    }
  }
}
